/**
 * CAP-40007 TCL-2727 - Async route guard backed by PingFederate OIDC.
 * Waits for OidcAuthService.isDoneLoading$ (the discovery + token-exchange phase)
 * before checking the token. This prevents the guard from firing before the callback
 * has been processed and avoids the blank-page / state-mismatch issues.
 */
import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OidcAuthService } from './oidc-auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(private oidc: OidcAuthService) {
  }

  // CAP-40007 TCL-2727 - Return Observable so the router waits until OIDC init completes.
  canActivate(): Observable<boolean> {
    return this.oidc.isDoneLoading$.pipe(
      // CAP-40007 TCL-2727 - Wait until loadDiscoveryDocumentAndLogin() has finished.
      filter(done => done),
      map(() => {
        // CAP-40007 TCL-2727 - After OIDC init, check if we have a valid access token.
        if (this.oidc.isAuthenticated) {
          return true;
        }
        // TCL-22 SECURITY - IDP returned ?error=access_denied (user has no SA/role assigned).
        // Do NOT redirect back to PingFederate here: the IDP would just deny again,
        // causing an infinite login <-> access_denied redirect loop. The dedicated
        // "Access Denied" message has already been shown by OidcAuthService.
        if (this.oidc.isAccessDenied) {
         
          return false;
        }
        // CAP-40007 TCL-2727 - No token — redirect to PingFederate login page.
        this.oidc.login();
        return false;
      })
    );
  }

}